import { Provider } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { EscapableDialogService } from './escapable-dialog.service';

export const ESCAPABLE_DIALOG_SERVICE_PROVIDER: Provider = { provide: DialogService, useClass: EscapableDialogService };
